<template>
  <p-input-group
    class="form-percentage-input"
    :class="{ narrow: !fullWidth }"
  >
    <p-input-text
      ref="inputField"
      v-model="percentageValue"
      type="text"
      autocomplete="off"
      :autofocus="autofocus"
      :placeholder="placeholder"
      :invalid="isValid === false"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @keyup.enter="$emit('blur')"
    ></p-input-text>
    <p-input-group-addon>%</p-input-group-addon>
  </p-input-group>
</template>

<script>
export default {
  name: 'percentageInput',
  props: {
    modelValue: {},
    validationCallback: Function,
    useWholePercent: {
      // use 50 instead of .50
      type: Boolean,
      default: false
    },
    allowNull: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Percentage'
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      percentageValue: ''
    }
  },
  computed: {
    isValid () {
      if (this.validationCallback) {
        return this.validationCallback(this.percentageValue)
      } else {
        return null
      }
    }
  },
  watch: {
    percentageValue (newValue) {
      if (this.allowNull && (newValue === '' || newValue === null || newValue === undefined)) {
        this.$emit('update:modelValue', newValue)

        return
      }

      this.$emit('update:modelValue', this.useWholePercent ? newValue : newValue / 100)
    },
    modelValue: {
      handler () {
        if (this.allowNull && (this.modelValue === null || this.modelValue === undefined)) {
          return
        }

        // This is some hacky JavaScript to get around the fact that Javascript can't really do math very well.
        // EXAMPLE: in the JS console try multiplying 0.29 * 100, then try multiplying 0.29 * 1000 / 10
        this.$setCompat(this, 'percentageValue', this.useWholePercent ? this.modelValue : (this.modelValue * 1000) / 10)
      },
      immediate: true
    }
  },
  mounted () {
    if (this.allowNull && (this.modelValue === null || this.modelValue === undefined)) {
      this.percentageValue = this.modelValue

      // return
    }
    if (this.autofocus) {
      this.$refs.inputField.$el.focus()
    }
  }
}
</script>

<style scoped>
.narrow {
  width: 9em;
}
</style>
